import FAVICONS from 'shared/favicons';
import defineSection from '~/spa/section';
import sectionHead from '~/spa/head';
import STORY_DETAIL_PAGE_CHILDREN from './storyDetailPageChildren';

export default defineSection({
    head: sectionHead({icon: FAVICONS.default, titleTemplate: '%s - Story - Multi Me'}),
    routes: [
        {
            path: '/stories/:storyId(\\d+)/',
            component: () => import(/* webpackChunkName: "story" */ './StoryDetailPage'),
            children: STORY_DETAIL_PAGE_CHILDREN,
            props: true,
            name: 'StoryDetailPage',
        },
    ]
});
